import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { MessagePayload, PostMessageResponse } from "../schemas/messaging";

export const usePostMessage = () => {
  const client = useApiClient();

  return useMutation<PostMessageResponse, Error, MessagePayload>(args => client.postMessage(args));
};
